// Copied from 'https://github.com/angular/angular/blob/master/packages/router/src/shared.ts' to set a reason in navigation canceled event
export const NAVIGATION_CANCELING_ERROR = 'ngNavigationCancelingError';

export function navigationCancelingError(message: string) {
  const error = Error('NavigationCancelingError: ' + message);
  (error as any)[NAVIGATION_CANCELING_ERROR] = true;
  return error;
}
